import * as Switch from '@radix-ui/react-switch'

type Props = {
    checked: boolean
    onCheckedChange: (checked: boolean) => void
    'data-test'?: string
}

export const AstraSwitch = ({ checked, onCheckedChange, 'data-test': dataTest }: Props) => (
    <Switch.Root
        checked={checked}
        onCheckedChange={onCheckedChange}
        className={`relative h-4 w-7 rounded-full transition-colors ${checked ? 'bg-brand-strong-selected' : 'bg-neutral-strong-rest/50'}`}
    >
        <Switch.Thumb
            data-test={dataTest}
            className={`block h-[14px] w-[14px] rounded-full bg-surface-base transition-transform will-change-transform ${checked ? 'translate-x-[13px]' : 'translate-x-[1px]'}`}
        />
    </Switch.Root>
)
